var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('StaffCountCard',{staticClass:"mr-4 mb-5 mb-lg-0",on:{"card-clicked":_vm.goToStaff}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }